/**
 * This is just a landscape carousel with background images at the back
 *
 */

import 'components/carousels/JsCarousel.js';
import { SwiperCarouselLandsCapeBreakpoints } from 'components/settings/BreakpointSettings';

export default function (customOptions = {}) {
    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('#lightning-carousel');
    let backgroundImage = false;

    wrapper.on('videoDataLoad', (e, result) => {
        // lightning background image
        if ('background_image' in result) {
            if (!backgroundImage) {
                if (backgroundImage !== result.background_image) {
                    backgroundImage = result.background_image;
                    wrapper
                        .closest('.lightning-container')
                        .find('.background-image')
                        .attr('data-bg', 'url(' + backgroundImage + ')');

                    // lightning background hex color
                    if (typeof result.background_hex_color !== 'undefined') {
                        let backgroundHexColor = result.background_hex_color;
                        wrapper
                            .closest('.lightning-container')
                            .find('.background-image')
                            .css('background-color', '#' + backgroundHexColor);
                    }

                    // lightning background gradient
                    if (typeof result.gradient_hex_color !== 'undefined') {
                        let gradientHexColor = result.gradient_hex_color;
                        wrapper
                            .closest('.lightning-container')
                            .find('.lightning-gradient')
                            .css({
                                backgroundImage:
                                    'linear-gradient(to bottom, transparent, #' +
                                    gradientHexColor +
                                    ')'
                            });
                    }

                    CBS.Registry.lazyImage.update();
                }
            }
        }
    });

    let defaultOptions = {
        responsive: SwiperCarouselLandsCapeBreakpoints
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);

    wrapper.JsCarousel(endOptions);
}
